import { createModelSchema } from '@services/EntityCache';

export interface IIdeaBankDetails {
  accountNumber?: string;
  addressHint?: string;
  bankAddress?: string;
  bankName?: string;
  bankRouting?: string;
  beneficiaryAddress?: string;
  beneficiaryName?: string;
  purposeOfPayment?: string;
  swift?: string;
}

export class IdeaBankDetails implements IIdeaBankDetails {
  accountNumber?: string;

  addressHint?: string;

  bankAddress?: string;

  bankName?: string;

  bankRouting?: string;

  beneficiaryAddress?: string;

  beneficiaryName?: string;

  purposeOfPayment?: string;

  swift?: string;
}

export const moneySchema = createModelSchema(IdeaBankDetails, {
  accountNumber: true,
  addressHint: true,
  bankAddress: true,
  bankName: true,
  bankRouting: true,
  beneficiaryAddress: true,
  beneficiaryName: true,
  purposeOfPayment: true,
  swift: true
});
